module.exports = __webpack_public_path__ + "static/img/12.908a675.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/eng/12.png
// module id = uLJj
// module chunks = 0